/***************************************************
 Youtube Replacer
***************************************************/
// Based on Amit Agarwal's Light YouTube Embeds
// Original script: http://labnol.org/?p=27941
// - Replaces video placeholder with thumbnail

function youtubeReplacer(){
  var playerClass = "is-youtube-player"; // Main player class
  var div, n,
    v = document.getElementsByClassName(playerClass);

  for (n = 0; n < v.length; n++) {
    v[n].innerHTML = getThumbnailContent(v[n].dataset.id);
    v[n].addEventListener('click', setIframe);
  }

  function getThumbnailContent(id) {
    // Creates thumbnail markup
    var thumb = '<img src="https://i.ytimg.com/vi/ID/hqdefault.jpg">',
        play = '<div class="play"></div>';

    return thumb.replace("ID", id) + play;
  }

  function setIframe(event) {
    // Creates iframe markup
    var iframe = document.createElement("iframe");
    var embed = "https://www.youtube.com/embed/ID?&autoplay=1&rel=0";
    var element = event.currentTarget; 

    iframe.setAttribute("src", embed.replace("ID", element.dataset.id));
    iframe.setAttribute("frameborder", "0");
    iframe.setAttribute("allowfullscreen", "1");
    iframe.setAttribute("allow", "accelerometer; autoplay; ");

    element.innerHTML = "";
    element.appendChild(iframe);

    src="https://www.youtube.com/embed/RS9Jl5M3DDg" 
    frameborder="0" 
  }
}


/***************************************************
  Document init
***************************************************/
// DOM Loaded
DOMReady(function() {
  if(document.querySelector(".is-youtube-player")) youtubeReplacer();
});